import { takeLatest, put, call, select } from 'redux-saga/effects';
import { WORKOUT_PAYMENT_SAGA } from "../sagaTypes";
import { loaderAction, setWorkoutPaymentFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { GetWorkoutsThunk } from "../thunks/GetWorkoutsThunk";
import { WORKOUT_PAYMENT_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/workout_payment`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerWorkoutPayment(args) {
    const user = yield select(state => state.user);
    const filterDate = yield select(state => state.filterDate);
    const pagination = yield select(state => state.pagination);
    const filterTypesOptions = yield select(state => state.filterTypesOptions);
    const filterCoachesOptions = yield select(state => state.filterCoachesOptions);
    const filterOneTimeWorkout = yield select(state => state.filterOneTimeWorkout);
    const filterConstraintsOptions = yield select(state => state.filterConstraintsOptions);
    const filterWorkoutsCountOptions = yield select(state => state.filterWorkoutsCountOptions);
    const filterUser = yield select(state => state.filterUser);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('workout_id', args.data.workout_id);
        formData.append('payment', args.data.payment);
        formData.append('discount', args.data.discount);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем тренировки
            yield put(GetWorkoutsThunk({
                page: pagination.current,
                from: filterDate.from,
                to: filterDate.to,
                subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
                subscription_constraints: JSON.stringify(filterConstraintsOptions.filter(el => el.active).map(el => el.id)),
                subscription_workouts_count: JSON.stringify(filterWorkoutsCountOptions.filter(el => el.active).map(el => el.id)),
                filter_user: filterUser.user.id,
                oneTime: filterOneTimeWorkout
            }));
            yield put(setWorkoutPaymentFormAction(WORKOUT_PAYMENT_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherWorkoutPayment() {
    yield takeLatest(WORKOUT_PAYMENT_SAGA, workerWorkoutPayment);
}